import FormProfileKYCPopup from './popup';

const FormProfileKYCModal = ({ isShow }) => {
  return (
    <>
      <FormProfileKYCPopup
        isOpen={isShow}
        isBackdropOverlap={true}
        zIndexBackdropOverlap={1068}
        zIndexModal={1069}
      />
    </>
  );
};

export default FormProfileKYCModal;
